
<template>
  <a-card title="任务类型说明">
    <div v-for="group in TaskStyleGroupOptions" :key="group.label">
      <div style="margin: 10px; color: #999;">{{group.label}}</div>
      <div  v-for="item in group.options" :key="item.label" style="margin-left: 20px; display: flex;">
        <div style="width: 20px; font-weight: bold;">{{item.value}}</div>
        <div style="margin-left: 10px;" >{{item.label}}
          <span v-if="item.disabled" style="color: red;">（已下线）</span>
        </div>
      </div>
    </div>
  </a-card>

</template>
<script>
import { defineComponent,  h,onMounted} from 'vue'
import { Modal, message } from 'ant-design-vue';

import request from '@/utils/request'
import { useStore } from 'vuex'
import {useRoute} from 'vue-router'
import { TaskStyleGroupOptions,SubTypeOptions ,StyleNames, ToolIDOptions} from '@/utils/macro'

export default defineComponent({
  components: {
  },  
  setup(props, context) {
    return {
    };
  },
  data(){
    return {
      loading: false,
      dataSource: [],
      pageNo: 0,
      StyleNames,TaskStyleGroupOptions,
      ToolIDOptions,
      preset_ids:"",
      SubTypeOptions:  SubTypeOptions,
      showFirst: false,
      statusOptions: [{
          label: "所有", value: '',
        },
        {
          label: "排队中", value: 0
        }, {
          label: "执行中", value: 1
        }, {
          label: "执行成功", value: 2
        }, {
          label: "执行失败", value: 3
        }, {
          label: "执行退出", value: 4
        }
      ],
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-quick-jumper': true,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '性能问题，总条数不再展示',

       formSearch: {
        is_oversea: false,
        template_id: '',
        tool_id: '',
        style_id: '',
        sub_type: '',
        status: '',
        user_id: '',
        task_id: '',
        queue_name: '',
        region_code: '',
      },

      uploadLoading: false,
    }
  },
  mounted(){
    // pass
  },
  computed:{
    
  },
  methods: {
   
    
  },

})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
.img-thumbnail {
  /* max-height: 355px; */
  width: 200px;
  overflow-y: scroll;
}
.thumbnail-wraps {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.prompt-container {
  cursor: pointer;
  max-height: 350px;
  max-width: 100px;
  overflow-y: scroll;
}
.prompt-container:hover {
  color: red;
}
</style>